import { commentConstants } from "../actions/constants/commentConstants";
import { request,success,failure } from "@/utils/constants"

export const getCommentsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commentConstants.getCommentsListRequest:
            return {
                ...request
            }
        case commentConstants.getCommentsListSuccess:
            return {
                ...success,
                data: action.payload,
            }
        case commentConstants.getCommentsListFailure:
            return {
                ...failure,
            }
        default:
            return state;
    }
}

export const addCommentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commentConstants.addCommentRequest:
            return { ...request }
        case commentConstants.addCommentSuccess:
            return { ...success, data: action.payload }
        case commentConstants.addCommentFailure:
            return { ...failure, error: action.payload }
        default:
            return state;
    }
}

export const editCommentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commentConstants.editCommentRequest:
            return { ...request }
        case commentConstants.editCommentSuccess:
            return { ...success, data: action.payload }
        case commentConstants.editCommentFailure:
            return { ...failure, error: action.payload }
        default:
            return state;
    }
}